package com.anjuros.website.templates.template4.modules


import com.anjuros.website.templates.template4.util.ResKey
import com.varabyte.kobweb.compose.ui.graphics.Colors
import org.jetbrains.compose.web.css.CSSColorValue

enum class Template4Section(
    val id:String,
    val title:ResKey,
    val color: CSSColorValue,
    val path:String
) {
    About_Me(
        id = "aboutme",
        title = ResKey.TEMPLATE4_SECTION1,
        color = Template4Theme.Secondary.rgb,
        path = "#aboutme"
    ),
    Project(
        id = "projects",
        title = ResKey.TEMPLATE4_SECTION2,
        color = Template4Theme.Secondary.rgb,
        path = "#projects"
    ),
    Gallery(
        id = "gallery",
        title = ResKey.TEMPLATE4_SECTION3,
        color = Template4Theme.Secondary.rgb,
        path = "#gallery"
    ),
    Testimonial(
        id = "testimonial",
        title = ResKey.TEMPLATE4_SECTION4,
        color = Colors.White,
        path = "#testimonial"
    ),
    Contact(
        id = "contact",
        title = ResKey.TEMPLATE4_SECTION5,
        color = Template4Theme.Secondary.rgb,
        path = "#contact")
}